import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from '@material-ui/core';
import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from '../styles';
import NotificationsActiveOutlinedIcon from '@material-ui/icons/NotificationsActiveOutlined';

const ReminderPopup = ({ data, type, open, onClose, onSubmit }) => {
  const classes = useStyles();

  const handleSubmit = () => {
    switch (type) {
      case 'reminder':
        onSubmit('reminder', data?.id);
        break;
      default:
        console.log('submit default');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <div className={classes.popupTitle}>
        <DialogTitle>
          <span>Send a reminder</span>
        </DialogTitle>
        <IconButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <Divider />
      <DialogContent>
        <div className={`${classes.minWidth250} ${classes.reminderBlock}`}>
          <div className={classes.reminderIconText}>
            <NotificationsActiveOutlinedIcon />
            <span>A reminder to {data?.tech_owner}</span>
          </div>
          <div className={classes.reminderContentPadding}>
            Lorem ipsum dolor sit amet consectetur. Id pellentesque lacus ut
            nisl congue risus molestie. Volutpat pharetra phasellus velit massa
            neque placerat auctor.
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="text">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReminderPopup;
